export function compressImage(
  file,
  {
    maxWidth = 1600,
    maxHeight = 1600,
    quality = 0.7
  } = {}
) {
  return new Promise((resolve, reject) => {
    if (!file?.type?.startsWith("image/")) {
      reject(new Error("Arquivo não é uma imagem"));
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();

      img.onload = () => {
        let { width, height } = img;

        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(
            maxWidth / width,
            maxHeight / height
          );
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Falha ao comprimir imagem"));
              return;
            }

            const compressedFile = new File(
              [blob],
              "evidencia.jpg",
              { type: "image/jpeg" }
            );

            resolve(compressedFile);
          },
          "image/jpeg",
          quality
        );
      };

      img.onerror = () => reject(new Error("Imagem inválida"));
      img.src = event.target.result;
    };

    reader.onerror = () => reject(new Error("Não foi possível ler a imagem selecionada"));
    reader.readAsDataURL(file);
  });
}
